export const DEFAULT_DEVICE: MediaDeviceInfo = {
  deviceId: 'default',
  groupId: '',
  kind: 'audiooutput',
  label: 'Default communication device',
  toJSON: () => {},
};
